<div class="content">
    <div class="w-full flex mb-2" *ngIf="showLegend" >
        <div *ngFor="let item of data?.datasets; let i = index" class="flex align-items-center mr-4 legend">
            <div class="border-circle border-2 label" [style.border-color]="item.color"></div>

            <div [style.color]="item.color" class="ml-2 title">
                {{ item.label }}
            </div>
        </div>
    </div>
    <p-chart type="line" [height]="'20rem'" [data]="data" [options]="options" #chart></p-chart>

        <!--[ngClass]="cursorPointer? 'cursor-pointer' : '' "-->

    <div id="tooltip" [style.display]="tooltip.display" [style.left]="tooltip.left" [style.top]="tooltip.right">
        <p [style.color]="tooltip.color" >
            {{ tooltip.text.title | date:"dd.MM.yyyy"}} 
        </p>
        <span>
            {{ tooltip.text.subtitle | currency : "BRL" }}
        </span>
    </div>
</div>